<template>
  <div :class="$style.CreatorCanvas">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ViewFrame'
};
</script>
<style scoped module>
.CreatorCanvas {
  @apply flex flex-col absolute pin-t w-full max-h-full bg-sh-pale-grey z-10 border border-grey-darkest;
}
</style>
